import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=850694a8&"
import script from "./SideBar.vue?vue&type=script&lang=ts&"
export * from "./SideBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('850694a8')) {
      api.createRecord('850694a8', component.options)
    } else {
      api.reload('850694a8', component.options)
    }
    module.hot.accept("./SideBar.vue?vue&type=template&id=850694a8&", function () {
      api.rerender('850694a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/SideBar.vue"
export default component.exports